
import { Component, Vue } from 'vue-property-decorator'
import { Field } from '@/services/utils/baseForm'
import { popUpRoute } from '@/services/utils/popupRoute'
import eventBus from '@/eventBus'
import { ModelApi } from '@/services/api/modelApi'
import { discountEndpoints } from '@/modules/inventory/discount'
import { IDiscount } from '@/modules/inventory/discount/types/discountTypes'
import { AmountType } from '@/modules/accounting/transaction-fee/types/transactionFeeTypes'

interface IFileSubmission {
  file: File
}

@Component({
  name: 'ImportDiscount',
  components: {
    BaseForm: () =>
      import(
        /* webpackChunkName : "BaseForm"*/ '@/stories/base-form/BaseForm.vue'
      ),
    DialogBaseSkeleton: () =>
      import(
        /* webpackChunkName : "DialogBaseSkeleton"*/ '@/stories/dialog-base-skeleton/DialogBaseSkeleton.vue'
      )
  }
})
export default class ImportDiscount extends Vue {
  id = this.$route.params.id || ''

  isDownloading = false

  /**
   * function will be passed to child components
   * @params file which will be uploaded for importing discount product variants
   */
  fields = () => [
    Field.file<IFileSubmission>('file', 'uploadDiscountFile')
      .setProps({
        accept: 'text/csv'
      })
      .setRules('ext:csv')
      .required()
      .setCol('col-12')
  ]

  /**
   * submit the data to the desired endpoint.
   */
  async handleSubmit(values: IFileSubmission) {
    try {
      // Get the discount data from sessionStorage (set by parent component)
      const discountDataString = sessionStorage.getItem('discountImportData')
      if (!discountDataString) {
        console.error('Discount data not found in session storage')
        return
      }

      const discountData = JSON.parse(discountDataString) as Pick<
        IDiscount,
        'amountType' | 'amount' | 'merchantId'
      >

      const response = await discountEndpoints.importProductVariants(
        {
          ...discountData,
          amount:
            discountData.amountType === AmountType.percentage
              ? discountData.amount / 100
              : discountData.amount
        },
        values.file
      )

      // Emit the result to any listening components via event bus
      eventBus.$emit('import-discount-success', response)

      // Clean up session storage
      sessionStorage.removeItem('discountImportData')

      // Refresh data and close popup
      eventBus.refreshData()
      this.closePopUp()
    } catch (error) {
      console.error('Import failed:', error)
    }
  }

  /** Download template for the current celery API type */
  async downloadTemplate() {
    try {
      this.isDownloading = true
      // Use ModelApi directly instead of specific endpoints
      const modelApi = new ModelApi('', '')
      await modelApi.downloadTemplate('discount')
    } finally {
      this.isDownloading = false
    }
  }

  closePopUp() {
    popUpRoute.removeModalPath(['id'])
  }
}
